import {Header, Logo} from './HeaderStyles'

const HeaderComponent = () => (
    <Header>
        <Logo title="MilkyMood logo" />
    </Header>
)

export default HeaderComponent